
var stache = require('can/view/stache/stache');
module.exports = stache("{{#if isVisible}}\r\n    <div class=\"c-backdrop js-backdrop\"></div>\r\n{{/if}}\r\n");